var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative slider-chat-input"},[_c('div',{ref:"closest"},[_c('FormEditable',{ref:"input",attrs:{"closest":_vm.$refs.closest,"grid":_vm.grid,"has-drop":_vm.hasDrop,"has-tags":"","has-mentions":"","upload-btn-icon":"attach","placeholder":_vm.$t(
          '_web_conversation_placeholder_enter-message',
          'Enter Your message'
        )},on:{"submit":function($event){return _vm.$emit('submit', $event)}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }